import * as React from 'react';
import { Icon } from '../../Icon';
import { IIcon } from '../../../interfaces/IIcon';

export function CheckmarkIcon({ width, height, viewBox, style, className }: IIcon) {
    const newViewProps = '0 0 16 16' ?? viewBox;
    return (
        <Icon
            width={width}
            height={height}
            viewBox={newViewProps}
            style={style}
            className={className}
        >
            <g>
                <path d="M15.6282 2.61531C15.1332 2.11961 14.3293 2.11992 13.8336 2.61531L5.75659 10.6926L2.1667 7.10279C1.671 6.60708 0.867479 6.60708 0.371777 7.10279C-0.123926 7.59849 -0.123926 8.40201 0.371777 8.89771L4.85894 13.3849C5.10664 13.6326 5.43143 13.7567 5.75625 13.7567C6.08107 13.7567 6.40617 13.6329 6.65387 13.3849L15.6282 4.41021C16.1239 3.91485 16.1239 3.11098 15.6282 2.61531Z" />
            </g>
        </Icon>
    );
}
